/**
 * 导航头-产品hover弹窗
 */

import React, { Component } from 'react';
import { Row, Col, Icon } from 'antd';
// import Link from 'next/link';
import './index.less';

class NewPopSolution extends Component {

  constructor(props) {
    super(props);
    this.state = {
        tabIndex: 0,
        maxContentHight: 356, //最大高度
    }
  }

    componentDidMount() {
        this.watchWindowSize()
        window.addEventListener('resize', this.watchWindowSize)
    }
    watchWindowSize = () => {
        let h = document.documentElement.clientHeight * 0.8
        this.setState({
            maxContentHight: h > 300 ? h : 300
        })
        console.log(h)
    }
  // tabs点击事件
 onTabsClick = (item,index) => {
    if(item.href&& item.href != ''){
        window.location.href = item.href
    }else{
        this.setState({
            tabIndex: index
        })
    }
    
 }
 onTabsMouseEnter = (item,index) => {
    // if(!(item.href&& item.href != '')){
        this.setState({
            tabIndex: index
        })
    // }
}
  render() {
    const { style = {}, title = "", data= [], extraText="",extraUrl="" } = this.props
    const { tabIndex, maxContentHight } = this.state;
    
    
    return (
    <div style={style} className="NewPop">
        <div className='NewPop-tabs' style={{maxHeight: (maxContentHight - 30) + 'px'}}>
            {data.map((item, index)=>{
                const hrefTag = item.href && item.href != '';
                return <div
                key={'NewPop-tabss-' + index}
                className={
                    `NewPop-tabs-items ${tabIndex == index ? 'NewPop-tabs-items-click' : ''} ${hrefTag ? 'NewPop-tabs-items-href' : ''}`
                } 
                onClick={()=>{
                    this.onTabsClick(item,index)
                    window.monitor && window.monitor.report({textKey: 'website_newpopsolution_left', text: item.title||''});
                }}
                onMouseEnter={()=>{this.onTabsMouseEnter(item,index)}}
                >
                    {item.title}
                    {!!hrefTag&&<img style={{width: '16px', height: '16px', marginTop: '0px'}} src={tabIndex == index ? 'https://resource.eziot.com/group2/M00/00/C3/CtwQFmVayeqAVNblAAAB0wTH9LQ159.png': 'https://resource.eziot.com/group2/M00/00/C3/CtwQF2Vayd6ALyH0AAAB2Bby-0E403.png'} />}
                </div>
            })}
            {/* {
                extraText && 
                <>
                    <div className="NewPop-divide"></div>
                    <div className='lastClass'>
                        <a className="NewPop-tabs-items cloud" target='_blank' href={extraUrl}>
                        <span className='iconImg'></span>
                        <div className='cloud-label'>{extraText}</div>
                        <Icon className="NewPop-tabs-items-href-icon" type="right" /></a>
                    </div>                   
                </>
            }           */}
        </div>

        <div style={{width: '100%', minHeight: '356px',minWidth:'100px',background: 'white', overflow: 'auto', maxHeight: (maxContentHight - 30) + 'px' }}>
            <Row gutter={20} style={{width:'100%',minWidth:'820px',paddingRight:'24px'}}>
                <div className='NewPop-content' style={{maxHeight: (maxContentHight - 32) + 'px'}}>
                    <Row align="stretch" gutter={20} style={{width:'100%'}}>
                        {(!!data[tabIndex].data&&!!data[tabIndex].data.length&&(!data[tabIndex].type|| data[tabIndex].type==1))&&data[tabIndex].data.map((tItem, tIndex)=>{
                            return <Col key={'NewPop-content-' + tIndex} span={6}>
                            {!!tItem&&!!tItem.length&&tItem.map((item, index)=>{
                                return <div key={'NewPop-content-'+ index + "-" + tIndex} className='NewPop-content-item'>
                                <div className='sub-item'>
                                    <div className='content-item-title'>{item.title}</div>
                                    <div className='sub-item-content'>
                                        <div className='sub-item-content-rank'>
                                            {item.subList.map((subItem,subIndex)=>{
                                                if(subItem.href.startsWith('http') || subItem.target == '_blank'){
                                                    return <a key={'subItem-rank-' + subIndex} 
                                                        target={subItem.target ||"_self"} 
                                                        href={subItem.href}
                                                        onClick={()=>{
                                                            window.monitor && window.monitor.report({textKey: 'website_newpopsolution_item_type', text: subItem.title||''});
                                                        }}
                                                        ><div className='content-sublist-item'>{subItem.title}</div></a>
                                                }
                                                return <a 
                                                    key={'subItem-rank-' + subIndex} 
                                                    href={subItem.href}
                                                    onClick={()=>{
                                                        window.monitor && window.monitor.report({textKey: 'website_newpopsolution_item_type', text: subItem.title||''});
                                                    }}
                                                    ><div className='content-sublist-item'>{subItem.title}</div></a>
                                            })}
                                        </div>
                                    </div>
                                    
                                </div>
                        </div>
                            })}
                        </Col>
                        })
                        }

                        {(!!data[tabIndex].data&&!!data[tabIndex].data.length&&data[tabIndex].type==2)&&data[tabIndex].data.map((tItem, tIndex)=>{
                            return <Col key={'NewPop-content2-' + tIndex} span={6}>
                                <div className='NewPop-content-item2' onClick={()=>{
                                    if(!!tItem.href){
                                        window.location.href = tItem.href
                                    }
                                    window.monitor && window.monitor.report({textKey: 'website_newpopsolution_item_type2', text: tItem.title||''});
                                }}>
                                    <div className='NewPop-content-item2-title'>{tItem.title}</div>
                                    <div className='NewPop-content-item2-desc'>{tItem.desc}</div>
                                </div>
                            </Col>
                        })}

                        {(!!data[tabIndex].data&&!!data[tabIndex].data.length&&data[tabIndex].type==3)&&data[tabIndex].data.map((tItem, tIndex)=>{
                            return <Col key={'NewPop-content-' + tIndex} span={4}>
                            {!!tItem&&!!tItem.length&&tItem.map((item, index)=>{
                                return <div key={'NewPop-content-'+ index + "-" + tIndex} className='NewPop-content-item'>
                                <div className='sub-item'>
                                    <div className='content-item-title'>{item.title}</div>
                                    <div className='sub-item-content'>
                                        <div className='sub-item-content-rank'>
                                            {item.subList.map((subItem,subIndex)=>{
                                                if(subItem.href.startsWith('http') || subItem.target == '_blank'){
                                                    return <a 
                                                        key={'subItem-rank3-' + subIndex}
                                                        target={subItem.target ||"_self"} 
                                                        href={subItem.href}
                                                        onClick={()=>{
                                                            window.monitor && window.monitor.report({textKey: 'website_newpopsolution_item_type3', text: subItem.title||''});
                                                        }}
                                                        >
                                                            <div className='content-sublist-item3'>
                                                                {!!subItem.icon&&<img src={subItem.icon} className='content-sublist-item3-icon' />}
                                                                <div className='content-sublist-item3-txt'>{subItem.title}</div>
                                                            </div>
                                                        </a>
                                                }
                                                return <a 
                                                    key={'subItem-rank3-' + subIndex}
                                                    href={subItem.href}
                                                    onClick={()=>{
                                                        window.monitor && window.monitor.report({textKey: 'website_newpopsolution_item_type3', text: subItem.title||''});
                                                    }}
                                                    >
                                                        <div className='content-sublist-item3'>
                                                            {!!subItem.icon&&<img src={subItem.icon} className='content-sublist-item3-icon' />}
                                                            <div className='content-sublist-item3-txt'>{subItem.title}</div>
                                                        </div>
                                                    </a>
                                            })}
                                        </div>
                                    </div>
                                    
                                </div>
                        </div>
                            })}
                        </Col>
                        })}
                    </Row>     
                </div>
            </Row>
        </div>

    </div>
    )
  }
}

export default NewPopSolution;
 